/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dashboard_Billing_Already_Billed_LabelInputs */



/**
* | output |
* | --- |
* | "Already billed this period" |
*
* @param {Dashboard_Billing_Already_Billed_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const dashboard_billing_already_billed_label = /** @type {((inputs?: Dashboard_Billing_Already_Billed_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dashboard_Billing_Already_Billed_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bereits in dieser Periode abgerechnet")
	return /** @type {LocalizedString} */ ("Already billed this period")
});